import { render, staticRenderFns } from "./customConfirm.vue?vue&type=template&id=0efc4f04&scoped=true"
import script from "./customConfirm.vue?vue&type=script&lang=js"
export * from "./customConfirm.vue?vue&type=script&lang=js"
import style0 from "./customConfirm.vue?vue&type=style&index=0&id=0efc4f04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efc4f04",
  null
  
)

export default component.exports